import {
    Card,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Slide,
    Table,
    TableCell,
    TableContainer,
    TableBody,
    TableRow,
    Grid,
    Typography,
    Tooltip,
    useTheme,
    Divider,
} from "@mui/material";
import { IconTractor, IconX } from "@tabler/icons-react";
import React, {
    forwardRef,
    useEffect,
    useState,
} from "react";
import { connect } from "react-redux";
import { setReportFilteredData } from "store/app/report-management/report-generations/actions";
import Chip from "ui-component/extended/Chip";

const Transition = forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);

const FieldLists = (props) => {

    const { open, onClose, birdRecord, farmName, reportData, reportName, reportValue } = props;
    let obj = {};
    const theme = useTheme();
    const [headers, setHeaders] = useState([]);
    const [formFields, setFormFields] = useState([]);
    useEffect(() => {
        const recordArr = birdRecord?.map((i) => {
            return [
                { BirdNo: i.BirdNo },
                ...i.FormRecordValues
            ]
        });
        const fieldsArr = recordArr?.map((field) => field?.map((i) => {
            if (i.FieldName) {
                return obj = {
                    ...obj,
                    [i.FieldName]: i.FieldValue
                }
            }
            else {
                return obj = {
                    ...obj,
                    BirdNo: i.BirdNo,
                }
            }
        }))
        const formattedFieldsArr = fieldsArr?.map((fields) => {
            return fields.reduce((field, object) => {
                return { ...field, ...object }
            })
        })
        setFormFields(formattedFieldsArr);
        const singleRecordData = formattedFieldsArr?.length > 0 ? formattedFieldsArr[0] : {};
        const headersArr = Object.keys(singleRecordData).length > 0 ? Object.keys(singleRecordData) : [];
        setHeaders(headersArr)
    }, [open]);

    const valueNamingConverter = (value) => {
        if (typeof (value) === "number") return value;
        switch (value?.toLowerCase()) {
            case "yes":
                return "Present";
            case "no":
                return "Absent";
            default:
                return value;
        }
    }

    return (
        <>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                maxWidth={'md'}
                fullWidth
                keepMounted
                sx={{
                    '&>div:nth-of-type(3)': {
                        '&>div': {
                            m: 0,
                            maxHeight: '100%'
                        }
                    }
                }}
            >
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                <Grid container alignItems="center" gap={2}>
                                    <Typography variant="h4">
                                        Fields Table
                                    </Typography>
                                    <Grid item>
                                        <Tooltip title="Farm Name" placement="top">
                                            <Chip
                                                sx={{ cursor: "pointer" }}
                                                label={farmName}
                                                chipcolor="secondary"
                                                icon={<IconTractor color={theme.palette.primary.main} />}
                                            />
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                >
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                <Grid container justifyContent="space-evenly"
                                    sx={{
                                        boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                                        borderRadius: "10px",
                                        py: 3,
                                        px: 1,
                                        mt: 2,
                                    }}>
                                    <Grid item>
                                        <Card sx={{
                                            bgcolor: theme.palette.secondary.main,
                                            // color: theme.palette.primary.main,
                                            color: "white",
                                            p: 2,
                                            textAlign: "center"
                                        }}>
                                            <Typography variant="h4" color="inherit">
                                                {reportName}
                                            </Typography>
                                            <Typography variant="caption" color="inherit">
                                                REPORT NAME
                                            </Typography>
                                        </Card>
                                    </Grid>
                                    <Grid item>
                                        <Card sx={{
                                            bgcolor: theme.palette.primary.main,
                                            // color: theme.palette.primary.main,
                                            color: "white",
                                            p: 2,
                                            textAlign: "center"
                                        }}>
                                            <Typography variant="h4" color="inherit">
                                                {reportData?.formula}
                                            </Typography>
                                            <Typography variant="caption" color="inherit">
                                                REPORT FORMULA
                                            </Typography>
                                        </Card>
                                    </Grid>
                                    <Grid item>
                                        <Card sx={{
                                            bgcolor: theme.palette.secondary.main,
                                            // color: theme.palette.primary.main,
                                            color: "white",
                                            p: 2,
                                            textAlign: "center",
                                        }}>
                                            <Typography variant="h4" color="inherit">
                                                {reportValue}
                                            </Typography>
                                            <Typography variant="caption" color="inherit">
                                                REPORT VALUE
                                            </Typography>
                                        </Card>
                                    </Grid>
                                </Grid>
                                <TableContainer sx={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", borderRadius: "10px", p: 1, mt: 2 }}>
                                    <Table size="small">
                                        <TableBody>
                                            {headers?.length > 0 ? headers?.map((fieldName, index) => (
                                                <TableRow key={index}>
                                                    <TableCell sx={{ fontWeight: "bold" }}>{fieldName === "BirdNo" ? "Bird No" : fieldName}</TableCell>
                                                    {formFields?.map((FieldValue, index) => {
                                                        return <TableCell
                                                            align="center"
                                                            key={index}
                                                            sx={{ fontWeight: fieldName === "BirdNo" ? "bold" : "normal" }}
                                                        >
                                                            {FieldValue[fieldName] ? valueNamingConverter(FieldValue[fieldName]) : "-"}
                                                        </TableCell>
                                                    })}
                                                </TableRow>
                                            ))
                                                : ""}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </DialogContent>
                        </Card>
                    </>
                )}
            </Dialog >

        </>
    )
}

const mapStateToProps = (state) => ({
    birdRecord: state.reportGeneration.birdRecord,
    farmName: state.reportGeneration.farmName,
    reportName: state.reportGeneration.reportName,
    reportValue: state.reportGeneration.reportValue,
    reportData: state.reportGeneration.reportGeneratedData,
})
const mapDispatchToProps = (dispatch) => ({
    setReportFilteredData: (filter) => dispatch(setReportFilteredData(filter)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FieldLists);